import { Metamodel } from 'app/model/base/model';
import { RelationalTableDataset } from 'app/model/dataset/relational-table.dataset';

import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { IViolation, IAttribute } from 'app/model/base/annotation';
import { RelationalCopySource } from 'app/model/pipeline/copysource/relational.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AmazonRedshiftTableDataset } from 'app/model/dataset/amazon-redshift.dataset';
import { IValidationContext, validateLinkedServicePermission } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.amazonRedshift.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(RelationalTableDataset),
            Metamodel.modelFor(AmazonRedshiftTableDataset)
        ]
    }
})
export class AmazonRedshiftCopySource extends RelationalCopySource {
    public static readonly BUCKET_NAME: IAttribute;

    // Trident doesn't support unload data through Amazon S3 for now.
    public enableRedshiftUnloadSettings: boolean = !__IS_FABRIC_DPE__;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL,
        constraint: {
            validator: AmazonRedshiftCopySource.validateLinkedService
        }
    })
    public linkedService: LinkedService;

    @Metamodel.attribute({
        templatable: true,
        association: 'BUCKET_NAME',
        display: stringResources.ModelName_BucketName,
        constraint: {
            validator: AmazonRedshiftCopySource.validatebucketName
        }
    })
    public bucketName?: string;

    private static validateLinkedService(copySource: AmazonRedshiftCopySource, value: LinkedService, violation?: IViolation, context?: IValidationContext): IViolation[] | undefined {
        if (copySource.enableRedshiftUnloadSettings) {
            if (!copySource.linkedService) {
                return [{
                    message: () => stringResources.SourceActivity_SourceTab_UnloadSetting_Missing_Linkedservice_ErrorMessage
                }];
            } else {
                return validateLinkedServicePermission(copySource.linkedService, context);
            }
        }
        return undefined;
    }
    private static validatebucketName(copySource: AmazonRedshiftCopySource): IViolation[] | undefined {
        if (copySource.enableRedshiftUnloadSettings && !copySource.bucketName) {
            return [
                {
                    message: () => stringResources.SourceActivity_SourceTab_UnloadSetting_Missing_Bucketname_ErrorMessage
                }
            ];
        }
        return undefined;
    }
}
